/**
 * usePMP Hook
 *
 * React Query hooks for PMP (Prix Moyen Pondere).
 * @see US-9.8 - Widget PMP
 */

import { useQuery } from '@tanstack/react-query';
import { pmpService } from '../services/goods-receipts.service';
import type { QueryPMPHistoryDto } from '@bstock/shared';

/**
 * Query key factory for PMP
 */
export const pmpKeys = {
  all: ['pmp'] as const,
  product: (rawProductId: string) => [...pmpKeys.all, rawProductId] as const,
  history: (rawProductId: string, params?: QueryPMPHistoryDto) =>
    [...pmpKeys.product(rawProductId), 'history', params] as const,
};

/**
 * Hook to fetch current PMP for a raw product
 */
export function usePMP(rawProductId: string | null) {
  return useQuery({
    queryKey: pmpKeys.product(rawProductId!),
    queryFn: () => pmpService.getPMP(rawProductId!),
    enabled: !!rawProductId,
  });
}

/**
 * Hook to fetch PMP history for a raw product
 */
export function usePMPHistory(rawProductId: string | null, params?: QueryPMPHistoryDto) {
  return useQuery({
    queryKey: pmpKeys.history(rawProductId!, params),
    queryFn: () => pmpService.getHistory(rawProductId!, params),
    enabled: !!rawProductId,
  });
}
